<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
<title>Remembering Farley</title>
<link href="style.css" rel="stylesheet" type="text/css"/>
<p class="text">Mom’s radar extends so far beyond me. She’s so
many people’s mom besides my own. A multispecies
mom. She’s takes in every stray animal. Drives injured
birds to the vet. Carries bugs outside to be reunited with
loved ones. Apologizes before squashing an ant.</p>
<p class="textn">She travels with as much as she can possibly carry
of what everyone might need. Band-aids. Glue. Tape.
Eye dropper. Paper clips. Sewing supplies. Ink remover.
Travel iron. Nail polish. Pliers. Sunscreen. Thermometer.
Juice box. Amphibian food.</p>
<p class="textn">Her purse is like a 15-pound rescue van.</p>
<p class="text">Her mind is like a purse. She has everything in
there. What to do if the child at the library gets the
hiccups. Who to call if the park bench has a rough spot
that might give a splinter. Where to find a map of Paris
at midnight in Toledo. How to tell if a cantaloupe is ripe.
What to say if a complete stranger looks a little bit sad.
What to write on a note that will change someone’s
whole outlook on life.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// mom008.vue?013437dc